import { VBtn } from 'vuetify/lib/components/VBtn';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(_setup.ListItemFilters, {
        attrs: {
          icon: "ui-icon-place",
          title: _setup.t(
            _setup.getPlaceLabel({ place: _setup.doctorFiltersState.place }),
            _setup.options
          ),
          subtitle: _setup.doctorFiltersState.place
            ? _setup.t(_setup.defaultPlaceName, _setup.options)
            : undefined,
        },
        on: { click: _setup.openDialog },
      }),
      _vm._v(" "),
      _c(_setup.PlaceModal, {
        attrs: { "is-back": "", value: _setup.isDialogOpened },
        on: { input: _setup.handleClosePlaceModal },
        scopedSlots: _vm._u([
          {
            key: "footer",
            fn: function ({ selectedPlace }) {
              return [
                _c(
                  "div",
                  { staticClass: "pa-2 elevation-8" },
                  [
                    _c(
                      VBtn,
                      {
                        attrs: {
                          block: "",
                          depressed: "",
                          color: "primary",
                          disabled: !_setup.hasUnsavedPlace,
                        },
                        on: {
                          click: function ($event) {
                            return _setup.handlePlaceSelected(selectedPlace)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_setup.t("Применить", _setup.options)) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }